import { LeaderboardListGroup } from '@neptune/shared/leaderboard-domain';
import { KnownAttributes } from 'domain/experiment/attribute';

export function extractGroupTagValue(group: LeaderboardListGroup | undefined): string | undefined {
  return group?.key.find(({ field }) => field.name === KnownAttributes.GroupTags)?.value?.[0];
}
